import { getQueryString } from '@/helpers/urlParse';

export const mapResponseFromTourByDomain = (responseData) => ({
  tourData: responseData.data.tourJson,
  branded: responseData.data.branded
});

export const mapResponseFromTourById = (responseData) => ({
  tourData: responseData.data.tour,
  branded: Boolean(+getQueryString('branded'))
});
